import React from 'react';
import { useSetRecoilState } from 'recoil';
import { overlayProppress } from '../../atoms/OverlayProgress';
import { flashMessageSuccess, flashMessageError } from '../../atoms/FlashMessage';
import { zshDialog } from '../../atoms/ZshDialog';
import { RouteComponentProps } from 'react-router-dom';
import DataTable, { DataTableRowsProps, DataTableBtnGroupProps } from '../../components/View/DataTable';
import * as _data_actions from '../../helper/dataActions';

function MailFromsIndex({ history, location }: RouteComponentProps) {

  const setOverlayProppress = useSetRecoilState(overlayProppress);
  const setFlashMessageSuccess = useSetRecoilState(flashMessageSuccess);
  const setFlashMessageError = useSetRecoilState(flashMessageError);
  const setZshDialog = useSetRecoilState(zshDialog);

  const clickCell = (callbackParams: any) => {
    history.push(location.pathname + '/' + callbackParams.data.id);
  }

  const handleToAdd = () => {
    history.push('/mail-froms/add');
  }

  const confirmDelete = (params: any) => {
    if (params.selected.length > 0) {
      _data_actions.showConfirmDialog({
        dialogType: 'delete',
        funcAgree: () => {
          handleDelete(params);
        },
        setZshDialog
      });
    } else {
      setFlashMessageError('項目を選択してください');
    }
  }

  const handleDelete = (params: any) => {
    _data_actions.deleteData({
      deleteUrl: 'mail-froms/delete/',
      selected: params.selected,
      getData: params.getData,
      setOverlayProppress,
      setFlashMessageSuccess,
      setFlashMessageError
    });
  }

  const rows: DataTableRowsProps[] = [
    {
      label: 'ID',
      value: 'id',
      sortField: 'MailFroms.id',
      align: 'left',
    },
    {
      label: 'From',
      value: 'email',
      align: 'left',
      sortField: 'MailFroms.email',
    },
    {
      label: '更新日時',
      value: 'modified',
      filter: 'YMDHm',
      sortField: 'MailFroms.modified',
      align: 'left',
    },
  ];

  const btnGroup: DataTableBtnGroupProps[] = [
    {
      title: '新規追加',
      func: handleToAdd,
      color: 'primary',
      role: {
        name: 'MailFroms',
        action: 'add',
      },
    },
    {
      title: '削除',
      func: confirmDelete,
      color: 'default',
      role: {
        name: 'MailFroms',
        action: 'delete',
      },
    },
  ];

  return (
    <div className="content-1">
      <DataTable
        rows={rows}
        checkbox={true}
        dataKey='mailFroms'
        jsonPath='mail-froms/index/index.json'
        urlQuery={true}
        parentProps={{ history, location }}
        handleClickCell={clickCell}
        btnGroup={btnGroup}
      />
    </div>
  )
}

export default MailFromsIndex;